<template>
  <div class="form-status">
    <span v-if="v.$invalid" class="fa fa-check-circle fa-3x text-danger"></span>
    <span v-else class="fa fa-check-circle fa-3x text-success"></span>
  </div>
</template>
<script>
export default {
  props: {
    v: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style scoped>
.form-status {
  position: absolute;
  right: 0;
  top: 0;
}
.fa-check-circle {
  opacity: 0.7;
}
</style>
